<nav attr.aria-label="{{ label() | translate }}">
  <a [id]="linkId()" [href]="href()" class="app-link--sr-only">{{
    label() | translate
  }}</a>
</nav>
